import styled, { css } from 'styled-components';
import Button from '@carvana/forms/Button';
import { cvBreakpoint768 } from '@carvana/theme';
import { WizardSection } from '../../document-wizard-modal.styles';

export const DocumentPreviewWrapper = styled(WizardSection)`
  align-items: center;
  background-color: ${props => props.theme.carvana.gray.background};
  display: flex;
  justify-content: center;
  padding: 40px 16px 56px;
  position: relative;
`;

export const FileImage = styled.embed`
  max-width: 462px;
  width: 100%;
`;

export const DocumentImageWrapper = styled.div`
`;

export const DocumentPreviewFooter = styled.footer`
  align-items: center;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  left: 0;
  padding: 0 16px 16px;
  position: absolute;
  right: 0;

  @media (min-width: ${cvBreakpoint768}px) {
    justify-content: flex-start;
  }
`;

export const FooterButton = styled(Button).attrs({
  ghost: true
})`
  border-color: transparent;
  font-size: 14px;
  height: 32px;
  min-height: auto;
  padding: 0;
  text-transform: none;
  width: 70px;
`;

export const FullViewButton = styled(FooterButton)`
  &:hover {
    background-color: inherit;
    color: ${props => props.theme.carvana.blue.primary};;
  }
`;

export const footerTextDividerStyles = css`
  color: ${props => props.theme.carvana.gray.medium};
  display: none;
  font-size: 14px;
  margin: 0 8px;

  @media (min-width: ${cvBreakpoint768}px) {
    display: block;
  }
`;

export const FileName = styled.p`
  color: ${props => props.theme.carvana.blue.dark};
  font-size: 12px;
  font-weight: bold;

  @media (min-width: ${cvBreakpoint768}px) {
    font-size: 14px;
  }
`;

export const ReuploadButton = styled(FooterButton)`
  @media (min-width: ${cvBreakpoint768}px) {
    border-color: inherit;
    margin-left: auto;
    width: 120px;
  }
`;
